package ca.northroot.app.ui.components

import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ca.northroot.app.data.JobStatus
import ca.northroot.app.ui.theme.*

@Composable
fun NorthrootCard(
    modifier: Modifier = Modifier,
    containerColor: Color = MaterialTheme.colorScheme.surface,
    onClick: (() -> Unit)? = null,
    content: @Composable ColumnScope.() -> Unit
) {
    val cardColors = CardDefaults.elevatedCardColors(
        containerColor = containerColor,
        contentColor = when (containerColor) {
            MaterialTheme.colorScheme.primary -> MaterialTheme.colorScheme.onPrimary
            MaterialTheme.colorScheme.surface -> MaterialTheme.colorScheme.onSurface
            else -> contentColorFor(containerColor)
        }
    )

    if (onClick != null) {
        ElevatedCard(
            modifier = modifier,
            shape = RoundedCornerShape(24.dp),
            colors = cardColors,
            elevation = CardDefaults.elevatedCardElevation(defaultElevation = 2.dp),
            onClick = onClick,
            content = content
        )
    } else {
        ElevatedCard(
            modifier = modifier,
            shape = RoundedCornerShape(24.dp),
            colors = cardColors,
            elevation = CardDefaults.elevatedCardElevation(defaultElevation = 2.dp),
            content = content
        )
    }
}

@Composable
fun NorthrootBadge(
    status: JobStatus,
    modifier: Modifier = Modifier
) {
    val (bgColor, textColor, label) = when (status) {
        JobStatus.PENDING -> Triple(MaterialTheme.colorScheme.surfaceVariant, MaterialTheme.colorScheme.onSurfaceVariant, "PENDING")
        JobStatus.IN_PROGRESS -> Triple(NorthrootGold.copy(alpha = 0.15f), NorthrootGold, "ACTIVE")
        JobStatus.COMPLETED -> Triple(MaterialTheme.colorScheme.primary.copy(alpha = 0.15f), MaterialTheme.colorScheme.primary, "DONE")
        JobStatus.SKIPPED -> Triple(NorthrootRed.copy(alpha = 0.1f), NorthrootRed, "SKIPPED")
        JobStatus.CANCELLED -> Triple(MaterialTheme.colorScheme.errorContainer.copy(alpha = 0.5f), MaterialTheme.colorScheme.error, "CANCELLED")
        JobStatus.INVOICED -> Triple(MaterialTheme.colorScheme.primaryContainer.copy(alpha = 0.3f), MaterialTheme.colorScheme.primary, "INVOICED")
    }

    Surface(
        color = bgColor,
        shape = RoundedCornerShape(8.dp),
        modifier = modifier
    ) {
        Text(
            text = label,
            modifier = Modifier.padding(horizontal = 8.dp, vertical = 4.dp),
            style = MaterialTheme.typography.labelSmall,
            fontWeight = FontWeight.Bold,
            color = textColor
        )
    }
}

@Composable
fun NorthrootActionButton(
    text: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    icon: ImageVector? = null,
    containerColor: Color = MaterialTheme.colorScheme.primary,
    contentColor: Color = MaterialTheme.colorScheme.onPrimary
) {
    Button(
        onClick = onClick,
        modifier = modifier.height(48.dp),
        shape = RoundedCornerShape(12.dp),
        colors = ButtonDefaults.buttonColors(
            containerColor = containerColor,
            contentColor = contentColor
        ),
        elevation = ButtonDefaults.buttonElevation(defaultElevation = 2.dp)
    ) {
        if (icon != null) {
            Icon(icon, contentDescription = null, modifier = Modifier.size(18.dp))
            Spacer(Modifier.width(8.dp))
        }
        Text(text, fontWeight = FontWeight.Bold, fontSize = 14.sp)
    }
}
